/* eslint-disable comma-dangle */
/* eslint-disable semi */
// ** Reducers Imports
import { combineReducers } from "@reduxjs/toolkit";
import layout from "./layout";
import navbar from "./navbar";
import login from "./login";
import adminProfile from "./adminProfile";
import competitions from "./competitions";
import users from "./users";
import adds from "./adds";
import fetchWinners_participants from "./participants&winners";
const rootReducer = combineReducers({
  navbar,
  layout,
  login,
  adminProfile,
  competitions,
  users,
  adds,
  fetchWinners_participants,
});

export default rootReducer;
